import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'adm-department-change-dialog',
  templateUrl: './charging-user-department-change-dialog.component.html',
  styleUrls: ['./charging-user-department-change-dialog.component.scss'],
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButtonModule, MatIconModule],
})
export class DepartmentChangeDialogComponent {
  dialogRef = inject<MatDialogRef<DepartmentChangeDialogComponent>>(MatDialogRef);

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
